import { ContractWriteParams, GasFeeMetrics, GasFeeSimulationResults } from '@src/types/gasFees'

export async function simulateSolanaGasFees(
    // @ts-ignore
    transactions: ContractWriteParams[],
    // @ts-ignore
    gasFeeMetrics: GasFeeMetrics
): Promise<GasFeeSimulationResults> {
    throw new Error('Solana not yet implemented')
}
